import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsIRole, MpsIUser } from '../interfaces/mps-user.interface';

export class MpsUser implements MpsIUser {
  id!: number;
  firstname!: string;
  lastname!: string;
  email!: string;
  lang!: string;
  last_connection!: string;
  igg!: string;
  role_id!: number;
  deleted_at?: string | null;
  purge_scheduled_at?: string | null;

  role!: MpsRole;

  constructor(data = {}) {
    Object.assign(this, data);
  }

  isAdmin() {
    return this.isRole(MpsRoleHelper.ADMIN);
  }

  isRole(roleCode: string) {
    return MpsRoleHelper.getRoleIdFromCode(roleCode) === this.role_id;
  }
}

export class MpsRole implements MpsIRole {
  id!: number;
  label!: string;
  code!: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
